import type { App } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

export const setupElementPlus = (app: App<Element>) => {
  // ⚠️ 关键修复：在加载 element-plus 前，确保 XMLHttpRequest 是原生版本
  if (typeof window !== "undefined" && window.__ORIGINAL_XMLHttpRequest__) {
    try {
      const testXhr = new window.XMLHttpRequest();
      if (!testXhr || typeof testXhr.upload === "undefined") {
        // 如果当前 XMLHttpRequest 无效，强制恢复原生版本
        window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
        console.log(
          "[ElementPlus Setup] XMLHttpRequest restored before loading ElementPlus",
        );
      } else {
        // 即使有效，也确保使用原生版本（防止被替换）
        window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
      }
    } catch (e) {
      window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
    }
  }

  app.use(ElementPlus);

  // 加载后再次检查
  if (typeof window !== "undefined" && window.__ORIGINAL_XMLHttpRequest__) {
    setTimeout(() => {
      try {
        const testXhr = new window.XMLHttpRequest();
        if (!testXhr || typeof testXhr.upload === "undefined") {
          window.XMLHttpRequest = window.__ORIGINAL_XMLHttpRequest__;
          console.log(
            "[ElementPlus Setup] XMLHttpRequest restored after loading ElementPlus",
          );
        }
      } catch (e) {}
    }, 0);
  }
};
